import { Component, computed, linkedSignal, OnDestroy, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { UrlParams } from 'src/app/models/enums/Route.enum';
import { Categories, Category, Rule } from 'src/app/models/types/Rule/Rule.type';
import { Tab, Tabs } from 'src/app/models/types/Tabs.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { RulesService } from 'src/app/services/api/rules.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { CategoryBodyComponent } from './category-body/category-body.component';
import { CategoryHeaderComponent } from './category-header/category-header.component';
import { HewCategoryComponent } from './hew-category/hew-category.component';

@Component({
  selector: 'app-rule',
  imports: [
    SharedModule,
    HewCategoryComponent,
    CategoryHeaderComponent,
    CategoryBodyComponent,
  ],
  templateUrl: './rule.component.html',
  styleUrl: './rule.component.scss'
})
export class RuleComponent implements OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  public rule: Signal<Rule | undefined> = linkedSignal(() => this.rulesService.selectedRule());

  public categoryHeader: Signal<Categories | undefined> = computed(() => this.rulesService.getCategoryHeader(this.rulesService.selectedRule()));

  public categoryBody: Signal<Categories[] | undefined> = computed(() => this.rulesService.getCategoryBody(this.rulesService.selectedRule()));

  private _tabs: Tabs = [];
  public get tabs(): Tabs { return this._tabs }

  constructor(
    private readonly scrollService: ScrollService,
    public readonly rulesService: RulesService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.scrollService.scrollTop();

    this.route.paramMap.pipe(
      takeUntil(this._destroying$)
    ).subscribe((params) => {
      this.rulesService.loadSelectedRule(params.get(UrlParams.Rule));
      this.loadTabs();
    })
  }

  loadTabs() {
    if (this.rulesService.rules) {
      this._tabs = this.rulesService.rules.map(child => {
        return {
          id: child.id,
          name: child.name,
          routerLink: this.rulesService.getRulePageUrl(child),
        } as Tab;
      });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  handleCategoryClick(child: Category) {
    let url = this.rulesService.getCategoryPageUrl(child);
    this.router.navigate([url]);
  }
}
